import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {VoidAuditReportData} from "./void-audit-report.data";

@Injectable()
export class VoidAuditReportModel extends ReportModel<VoidAuditReportData> {
    constructor(injector: Injector) {
        super(injector, VoidAuditReportData);
    }
}
